<template>
  <div class="borrowMoneylist">
    <!-- 表单搜索 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="onHandleRefresh"
      @search="onSearch"
    ></Filtersearch>
    <!-- 表单搜索 end -->

    <!-- 列表 start -->
    <div class="table-wrap">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column label="商品名称" prop="skuName" align="center">
        </el-table-column>
        <el-table-column label="货号" prop="skuCode" align="center">
        </el-table-column>
        <el-table-column label="发品采购" prop="buyerName" align="center">
        </el-table-column>
        <el-table-column label="操作人" prop="oprator" align="center">
        </el-table-column>
        <el-table-column label="删除时间" prop="removeTime" align="center">
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDel(scope.row)"
              >恢复</el-button
            >
          </template>
        </el-table-column>
        <!-- 列表操作栏 end -->
      </el-table>
    </div>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <!-- <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div> -->
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import cloneDeep from "lodash/cloneDeep";
import throttle from "lodash/throttle";
export default {
  name: "delGoods",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "input",
          name: "货号",
          clearable: true,
          model: "sku_code",
          placeholder: "请输入货号",
        },
      ],
      loading: false,
      logo: [],
      formData: {
        sku_code: "", //
        page: 1,
        pageSize: 100,
      }, // 表单参数
      formDataClone: {}, // 表单参数拷贝，用于重置
      tableData: [], // 城市仓列表
      total: 0,
      btndisabled: false,
    };
  },
  mounted() {
    this.onInitData();
  },
  methods: {
    handleDel(row) {
      this.$confirm("是否确认恢复，恢复后在商品下架列表展示", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.borrowMoney
            .deletereset({
              sku_code: row.skuCode,
            })
            .then((res) => {
              console.log(res, "停用或者开启");
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.formData.sku_code = "";
              this.tableData = [];
              // this.ajaxGetTableList();
            });
        })
        .catch(() => {});
    },
    ajaxGetTableList() {
      this.loading = true;
      this.$api.borrowMoney
        .deleteinfo(this.formData)
        .then((res) => {
          this.tableData = [res.data];
          console.log("tableData", this.tableData);
          this.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    /**
     * 初始化
     */
    onInitData() {
      this.formDataClone = cloneDeep(this.formData);
      // this.ajaxGetTableList();
    },

    /**
     * 重置表单，并刷新
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.ajaxGetTableList();
    },
    /**
     * 搜索表单
     */
    onSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.ajaxGetTableList();
    },

    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.ajaxGetTableList();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.ajaxGetTableList();
    },
  },
};
</script>
<style lang="scss">
.borrowMoneylist {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .table-wrap {
    flex-grow: 1;
    overflow-y: hidden;
    .text-btn {
      color: $theme-color;
      cursor: pointer;
    }
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
